<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <ValidationObserver
              v-slot="{ handleSubmit, invalid, touched }"
              ref="updateForm"
            >
              <form
                class="authentication-form"
                @submit.prevent="handleSubmit(createPlan)"
              >
                <div class="row">
                  <div class="col-md-6">
                    <TextInput
                      v-model="plan.name"
                      name="name"
                      rules="required"
                      label="Plan Name"
                    />
                  </div>
                  <div class="col-md-6">
                    <TextInput
                      v-model="plan.desc"
                      name="name"
                      rules="required"
                      label="Plan Desc."
                    />
                  </div>
                  <div class="col-md-6">
                    <TextInput
                      v-model="plan.price"
                      name="price"
                      rules="required|min_value:1"
                      label="Price ($)"
                      type="number"
                    />
                  </div>
                  <div class="col-md-6">
                    <label>Interval</label>
                    <select v-model="plan.interval" class="form-control">
                      <option
                        v-for="interval in intervals"
                        :key="interval.key"
                        :value="interval.key"
                        >{{ interval.label }}</option
                      >
                    </select>
                  </div>
                  <div class="col-md-6">
                    <TextInput
                        v-model="plan.trial_period_days"
                        rules="numeric"
                        name="trial_period_days"
                        label="Free Trial Days"
                        type="number"
                    />
                  </div>
                  <div v-if="isSalePlan" class="col-md-6">
                    <TextInput
                      v-model="plan.video"
                      name="video"
                      label="Video"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label class="form-control-label">Product Type</label>
                    <b-form-select v-model="plan.db_plan.product_type" :options="[{ value: 'ReplyEngine', text: 'ReplyEngine' }, { value: 'TapEngine', text: 'TapEngine' }, { value: 'SocialReview', text: 'SocialReview' }, { value: 'ReviewSurge', text: 'ReviewSurge' },{ value: 'LeadMachine', text: 'LeadMachine' }, { value: 'SocialFusion', text: 'SocialFusion' }, { value: 'InstaStream', text: 'InstaStream' }, { value: 'RepuAgency', text: 'RepuAgency' }, { value: 'ZenSocial', text: 'ZenSocial' }]" @change="updatePlanProducts"  />
                  </div>
                  <div class="col">
                    <TextInput
                        v-model="plan.db_plan.max_customers"
                        name="max-customers"
                        label="Max. Customers"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label class="form-control-label mb-3">Plan Products</label>
                    <b-form-checkbox-group v-model="plan.db_plan.planProducts">
                      <div v-for="planProduct in ['ReplyEngine', 'TapEngine', 'SocialReview', 'ReviewSurge','LeadMachine', 'SocialFusion', 'InstaStream', 'RepuAgency', 'ZenSocial']" :key="planProduct" class="mb-3">
                        <b-form-checkbox
                            :value="planProduct"
                            :disabled="plan.db_plan.product_type === planProduct"
                        >
                          {{ planProduct }}
                        </b-form-checkbox>
                      </div>

                    </b-form-checkbox-group>
                  </div>
                </div>
                <div class="row d-none">
                  <div class="col-12 col-sm-6">
                    <label class="form-control-label">Upsells</label>
                    <b-form-select v-model="plan.db_plan.upsells" multiple :options="[{ name: 'No Upsell', id: null },...plans]" text-field="name" value-field="id"  />
                  </div>
                </div>
                <h5 class="h5">Features</h5>
                <table class="table table-bordered meta-table">
                  <thead class="thead-light">
                    <tr>
                      <th>Key</th>
                      <th>Value</th>
                      <!-- <th></th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in plan.metadata" :key="index">
                      <td>
                        <strong>{{item.key}}</strong>
                      </td>
                      <td>
                        <TextInput
                          v-if="item.key === 'Number of Businesses'"
                          v-model="item.value"
                          name="value"
                        />
                        <b-form-checkbox
                          v-else
                          v-model="item.value"
                          name="check-button"
                          switch
                          inline
                          class="mt-2"
                        >
                        </b-form-checkbox>
                      </td>
                    </tr>
                    <tr v-if="!isSalePlan">
                      <td>
                        <strong>Visible</strong>
                      </td>
                      <td>
                        <b-form-checkbox
                          v-model="plan.visible"
                          name="check-button"
                          switch
                          inline
                          class="mt-2"
                        >
                        </b-form-checkbox>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Premium Plan</strong>
                      </td>
                      <td>
                        <b-form-checkbox
                            v-model="plan.db_plan.premium_plan"
                            name="check-button"
                            switch
                            inline
                            class="mt-2"
                        >
                        </b-form-checkbox>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <b-form-group>
                  <b-button
                    variant="primary"
                    :disabled="loadingCreate || (invalid && touched)"
                    type="submit"
                  >
                    <b-spinner v-if="loadingCreate" small />
                    <span v-else>Create</span>
                  </b-button>
                </b-form-group>
              </form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loadingCreate: false,
      intervals: [
        { key: 'day', label: 'Daily' },
        { key: 'week', label: 'Weekly' },
        { key: 'month', label: 'Monthly' },
        { key: 'year', label: 'Yearly' },
        { key: 'one-time', label: 'One-Time'}
      ],
      plan: {
        interval: 'month',
        visible: true,
        metadata: [
          { key: 'Number of Businesses', value: 0 },
          { key: 'Sales Plan', value: false },
        ],
        db_plan:{
          upsells:[],
          product_type:'ReplyEngine',
          max_customers: null,
          premium_plan:false,
          planProducts:[]
        }
      },
      newFeature: {
        key: '',
        value: '',
      },
    }
  },

  computed: {
    plans() {
      return this.$store.getters['subscription/allPlans'] || [];
    },

    isSalePlan() {
      let salePlan = this.plan.metadata.filter((f) => f.key === 'Sales Plan')[0]
      return salePlan && salePlan.value
    },
  },

  mounted() {
    if (!this.$store.getters['subscription/allPlans']) {
      this.$store.dispatch('subscription/getAllPlans')
    }
    this.updatePlanProducts();
  },

  methods: {
    updatePlanProducts() {
      // Reset planProducts and only check the new product_type
      this.plan.db_plan.planProducts = [this.plan.db_plan.product_type];
    },
    createPlan() {
      this.loadingCreate = true

      this.$store
        .dispatch('subscription/createPlan', this.plan)
        .then(() => {
          this.loadingCreate = false
          this.$router.push({ name: 'admin.plans.index' })
        })
        .catch((err) => {
          if (err.response.data.errors) {
            this.$refs.updateForm.setErrors(err.response.data.errors)
          }
          this.loadingCreate = false
        })
    },

    addMetadata() {
      this.plan.metadata.push(this.newFeature)
      this.newFeature = { key: '', value: '' }
    },

    removeMetadata(index) {
      this.plan.metadata.splice(index, 1)
    },
  },
}
</script>

<style lang="scss">
  .meta-table {
    td, th {
      vertical-align: middle;
    }
    .form-group {
      margin-bottom: 0!important;
    }
  }
</style>
